"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _GlobalAccessObjects_combineTextures, _GlobalAccessObjects_loadContent;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalAccessObjects = void 0;
class GlobalAccessObjects {
    constructor() {
        // #region Properties (3)
        _GlobalAccessObjects_combineTextures.set(this, void 0);
        _GlobalAccessObjects_loadContent.set(this, void 0);
        // #endregion Public Getters And Setters (4)
    }
    // #endregion Properties (3)
    // #region Public Static Getters And Setters (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Getters And Setters (1)
    // #region Public Getters And Setters (4)
    get combineTextures() {
        return __classPrivateFieldGet(this, _GlobalAccessObjects_combineTextures, "f");
    }
    set combineTextures(value) {
        __classPrivateFieldSet(this, _GlobalAccessObjects_combineTextures, value, "f");
    }
    get loadContent() {
        return __classPrivateFieldGet(this, _GlobalAccessObjects_loadContent, "f");
    }
    set loadContent(value) {
        __classPrivateFieldSet(this, _GlobalAccessObjects_loadContent, value, "f");
    }
}
exports.GlobalAccessObjects = GlobalAccessObjects;
_GlobalAccessObjects_combineTextures = new WeakMap(), _GlobalAccessObjects_loadContent = new WeakMap();
//# sourceMappingURL=GlobalAccessObjects.js.map